import log from 'loglevel'
import { isNil } from 'lodash/fp'
import { fetchUtils } from 'react-admin'

import {
  CognitoUserPool,
  type CognitoUserSession
} from 'amazon-cognito-identity-js'

import cognito from '../../../../cdk/cognitoApi/lib/lambda-api/src/clients/userPools.json'

const env = process.env['ENV'] as string
const userPools: Record<string, { userPoolId: string; clientId: string }> =
  cognito[env as keyof typeof cognito]
export const url = !isNil(process.env['COGNITO_API_LOCAL'])
  ? 'http://localhost:14000/v1'
  : {
      prd: 'https://cognito-v2.sapp.terashite.jp/v1',
      stg: 'https://cognito-v2-stg.sapp.terashite.jp/v1',
      int: 'https://cognito-v2-int.sapp.dev.terashite.jp/v1',
      dev: 'https://cognito-v2-dev.sapp.terashite.jp/v1',
      exp: 'https://cognito-v2-exp.sapp.dev.terashite.jp/v1'
    }[env]
log.setLevel((process.env['LOG_LEVEL'] as log.LogLevelDesc) ?? log.levels.DEBUG)

export const getCustomHeaders = (
  options: fetchUtils.Options = {},
  partner: string | undefined
): Headers | undefined => {
  if (isNil(partner)) return undefined
  if (isNil(userPools[partner])) return undefined
  const { userPoolId: UserPoolId, clientId: ClientId } = userPools[partner]
  const userPool = new CognitoUserPool({
    UserPoolId,
    ClientId
  })
  const cognitoUser = userPool.getCurrentUser()
  if (isNil(cognitoUser)) return undefined
  let session: any
  cognitoUser.getSession(
    (error: Error, newSession: CognitoUserSession | null) => {
      if (!isNil(error)) {
        log.error('[DataProvider.fetchJson]', { error })
        return
      }
      session = newSession
    }
  )
  if (isNil(session)) return undefined
  const customHeaders = (
    !isNil(options.headers)
      ? options.headers
      : new Headers({
          Accept: 'application/json'
        })
  ) as Headers
  customHeaders.set('Authorization', session.getIdToken().getJwtToken())
  customHeaders.set('X-Partner', partner)
  return customHeaders
}
export const fetchJson =
  (partner: string | undefined) =>
  (url: string, options: fetchUtils.Options = {}): any => {
    const customHeaders = getCustomHeaders(options, partner)
    if (isNil(customHeaders)) return undefined
    options.headers = customHeaders
    return fetchUtils.fetchJson(url, options)
  }
